import React, { useRef } from "react";
import xMark from "../../img/x-mark.svg";
import arrowLeft from "../../img/arrow-left.svg";
import checkCircle from "../../img/check-circle-32.svg";

interface AuthModalLayoutProps {
  onClose: () => void;
  onBack?: () => void;
  showBackButton?: boolean;
  title?: string;
  children: React.ReactNode;
}

const AuthModalLayout: React.FC<AuthModalLayoutProps> = ({
  onClose,
  onBack,
  showBackButton = false,
  title,
  children,
}) => {
  const overlayMouseDownRef = useRef(false);

  const handleOverlayMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
    overlayMouseDownRef.current = event.target === event.currentTarget;
  };

  const handleOverlayMouseUp = (event: React.MouseEvent<HTMLDivElement>) => {
    const isOverlayMouseUp = event.target === event.currentTarget;

    if (overlayMouseDownRef.current && isOverlayMouseUp) {
      onClose();
    }

    overlayMouseDownRef.current = false;
  };

  const getTitle = (title: string) => {
    if (title === "Письмо отправлено") {
      return (
        <div className="tw-text-[#16A34A] auth-modal-title tw-flex tw-items-center tw-gap-2">
          <img src={checkCircle} alt="" className="auth-modal-title__icon" />
          {title}
        </div>
      );
    } else {
      return <div className="auth-modal-title ">{title}</div>;
    }
  };

  return (
    <div
      className="auth-modal-overlay"
      onMouseDown={handleOverlayMouseDown}
      onMouseUp={handleOverlayMouseUp}
    >
      <div className="auth-modal-content">
        <div className="auth-modal-header">
          <div className="auth-modal-header-left">
            {showBackButton && onBack && (
              <button
                type="button"
                className="auth-back-button"
                onClick={onBack}
                aria-label="Назад"
              >
                <img
                  src={arrowLeft}
                  alt=""
                  className="auth-back-button__icon"
                />
              </button>
            )}

            {title && getTitle(title)}
          </div>

          <button
            type="button"
            className="auth-close-button"
            onClick={onClose}
            aria-label="Close"
          >
            <img src={xMark} alt="" className="auth-close-button__icon" />
          </button>
        </div>

        <div className="auth-modal-body">{children}</div>
      </div>
    </div>
  );
};

export default AuthModalLayout;
